import { useAnimationTimerApi, useDrawToolbarApi } from "../../../components";
import { useFrameStencilsApi, usePlayStateApi, useSelectItemApi } from "../../../hooks";
import { SportPlay } from "../../../types";
import { useToolPaletteApi } from "./use-tool-palette-api";

export const usePlayContextApi = <TPlay extends SportPlay>(play: TPlay) => {
  const selectItemApi = useSelectItemApi();
  const playStateApi = usePlayStateApi(play);
  const { playState, updateActiveFrame, activeFrame, setActiveFrameId } = playStateApi;

  const frameStencilsApi = useFrameStencilsApi({ updateActiveFrame });

  const animationTimerApi = useAnimationTimerApi({ startTime: 0, play: playState, activeFrame, setActiveFrameId });

  const drawToolbarApi = useDrawToolbarApi({ selectItemApi, playStateApi, animationTimerApi, frameStencilsApi });

  const toolPaletteApi = useToolPaletteApi({ sport: playState.sport });

  return { selectItemApi, playStateApi, animationTimerApi, frameStencilsApi, drawToolbarApi, toolPaletteApi };
};

export type PlayContextApi = ReturnType<typeof usePlayContextApi>;
